import { inject, Injectable } from "@angular/core";
import { SegmentService } from "@main-services/segment.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Injectable({
	providedIn: "root"
})
export class BpStoriesTrackingFacade {
	private segmentService = inject(SegmentService);
	private rudderstackService = inject(RudderstackService);

	public trackStoryGroupClick(story_group: number, trigger: string): void {
		this.segmentService.track({
			name: "Story Group Clicked",
			properties: {
				story_group,
				trigger
			}
		});
		this.rudderstackService.track({
			name: "Story Group Clicked",
			properties: {
				story_group,
				trigger
			}
		});
	}

	public trackStoryViewed(storyGroupId: number, storyId: number): void {
		this.trackStory("Story Viewed", storyGroupId, storyId);
	}

	public trackStoryCTAClicked(storyGroupId: number, storyId: number): void {
		this.trackStory("Story CTA Clicked", storyGroupId, storyId);
	}

	public trackUserInteraction(type: string, storyGroupId: number, storyId: number): void {
		let text = null;
		switch (type) {
			case "poll":
				text = "Story Poll Answer Clicked";
				break;
			case "quiz":
				text = "Story Quiz Answer Clicked";
				break;
			case "rating":
				text = "Story Rating Clicked";
				break;
			default:
				return;
		}
		this.trackStory(text, storyGroupId, storyId);
	}

	public trackStoryGroupClosed(story_group: number): void {
		this.segmentService.track({
			name: "Story Group Close Clicked",
			properties: {
				story_group
			}
		});
		this.rudderstackService.track({
			name: "Story Group Close Clicked",
			properties: {
				story_group
			}
		});
	}

	private trackStory(name: string, story_group: number, story: number): void {
		this.segmentService.track({
			name,
			properties: {
				story_group,
				story
			}
		});
		this.rudderstackService.track({
			name,
			properties: {
				story_group,
				story
			}
		});
	}
}
